let ajaxPrefix = 'https://www.dfwdefense.com';

import './css/default/bootstrap.scss'
import './css/default/00-general.scss'
import './css/default/00-layout-helpers.css'
import './css/default/00-bootstrap-tweak.css'
import './css/default/00-larger-boostrap-container.scss'
import './css/default/print.css'

import jQuery from "jquery";

window.$ = window.jQuery = jQuery;

import 'popper.js';
import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/util';

import './js/main2';
import './js/nav';
/*
*/


function importAll(r) {
    r.keys().forEach(r);
}

importAll(require.context('./css/site', true, /\.css$/));
importAll(require.context('./css/site', true, /\.scss$/));



/*

function requireAll(requireContext) {
    return requireContext.keys().map(requireContext);
}

const loader = require.context('./js', true, /\.js$/);

console.log('loader', loader.keys());

requireAll(loader).forEach(requireCmp => {
    if (requireCmp && requireCmp.default) {
        requireCmp.default(app)
    } else {
        console.log('File failed to load: ', requireCmp);
        console.log(requireCmp);
    }
});



 */



// WEBPACK FOOTER //
// ./index.js